export default "__VITE_ASSET__b8d12b82__"